import React, { PureComponent, Fragment } from 'react';
import { Dropdown, VideoPlayer, Carousel, Button } from 'common/components';
import { help as HelpIcon } from 'common/svg/icons';
import { connect } from 'react-redux';
import { object } from 'prop-types';
import axios from 'axios';

import './index.css';
import videoData from './videos.static';

class OnboardingDropdown extends PureComponent {
  state = {
    currentVideo: {},
    videoList: [],
  };

  static propTypes = {
    location: object,
  };

  async componentDidMount() {
    const cachedData = JSON.parse(localStorage.getItem('videoList'));
    // use the cached data if it's not exipred
    if (cachedData && cachedData.expireAt > Date.now()) {
      this.setState({ videoList: cachedData.videoList });
    } else {
      await this.requestVideos();
    }

    // if no matching video found, use the first video as default
    if (!this.setCurrentVideo()) {
      this.setState(({ videoList }) => ({ currentVideo: videoList[0] }));
    }
  }

  componentDidUpdate(prevProps) {
    // change active video base on route
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setCurrentVideo();
    }
  }

  /**
   * set the current video if there is a matching path found
   * @function setCurrentVideo
   * @memberof OnboardingDropdown
   * @public
   */
  setCurrentVideo = () => {
    const { videoList } = this.state;
    const { pathname } = this.props.location;
    const currentVideo = videoList.find(v => v.path === pathname);
    if (currentVideo) {
      this.setState({ currentVideo });
    }
    return !!currentVideo;
  };

  /**
   *
   * @function handleThumbnailClick
   * @memberof OnboardingDropdown
   * @public
   */
  handleThumbnailClick = video => this.setState({ currentVideo: video });

  /**
   * make reques to youtube api to fetch video data
   * @function requestVideo
   * @memberof OnboardingDropdown
   * @public
   */
  requestVideos = async () => {
    const videoString = videoData.map(v => v.id).join(',');
    const requestUrl = 'https://www.googleapis.com/youtube/v3/videos';

    const { status, data } = await axios.get(requestUrl, {
      params: {
        part: 'snippet',
        id: videoString,
        key: process.env.REACT_APP_GOOGLE_API_KEY,
      },
    });
    if (status === 200) {
      const videoList = this.mapYoutubeResponse(data);
      // set one day as exipration
      const milliSecondsInDay = 60 * 60 * 24 * 1000;
      // cache video data
      localStorage.setItem(
        'videoList',
        JSON.stringify({ videoList, expireAt: Date.now() + milliSecondsInDay })
      );
      this.setState({ videoList });
    }
  };

  /**
   *
   * @function mapYoutubeResponse
   * @memberof OnboardingDropdown
   * @public
   */
  mapYoutubeResponse = data =>
    data &&
    data.items &&
    data.items.map(({ id, snippet: { title, thumbnails } }) => {
      const { path } = videoData.find(v => v.id === id) || {};
      return {
        id,
        title,
        thumbnail: thumbnails.standard.url,
        path,
      };
    });

  /**
   * Render video onboarding component
   * @function getVideos
   * @memberof OnboardingDropdown
   */
  getVideos = () => {
    const { currentVideo, videoList } = this.state;
    return (
      <Fragment>
        {currentVideo && (
          <VideoPlayer youtubeId={currentVideo.id} title={currentVideo.title} />
        )}
        <div className="onboardingdropdown__carousel">
          <Carousel
            options={{
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: false,
              arrows: false,
              dots: true,
              // nextArrow: <p>next</p>,
              // prevArrow: <p>prev</p>
            }}
          >
            {videoList &&
              videoList.map(video => {
                const { id, title, thumbnail } = video;
                return (
                  <div
                    className="onboardingdropdown__player__container"
                    key={id}
                    onClick={() => this.handleThumbnailClick(video)}
                  >
                    <VideoPlayer
                      youtubeId={id}
                      title={title}
                      thumbnail={thumbnail}
                    />
                  </div>
                );
              })}
          </Carousel>
        </div>
      </Fragment>
    );
  };

  render() {
    return (
      <Dropdown
        className="level-right"
        header={
          <Fragment>
            <h2 className="text--header text--medium onboardingdropdown__heading">
              Learn How
            </h2>
            <Button
              className="btn btn--primary onboardingdropdown__help-btn"
              onClick={() =>
                window.open('https://agihelp.zendesk.com/hc/en-us')
              }
            >
              HELP CENTRE
            </Button>
          </Fragment>
        }
        theme={['right', 'tight']}
        trigger={<HelpIcon />}
        unmountContentOnClose
      >
        {this.getVideos()}
      </Dropdown>
    );
  }
}

const mapState = ({ router: { location } }) => ({
  location,
});

export default connect(mapState)(OnboardingDropdown);



// WEBPACK FOOTER //
// ./src/containers/OnboardingDropdown/index.js